<syslink-grid
  #grid
  [canView]="canView"
  [gridName]="storageKey"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  [canDelete]="canDelete"
  [service]="StockMoveInternalsService"
  [columns]="columns"
  [filter]="filter"
  [canUpdate]="false"
  (add)="onAddButtonClicked()"
  [detailsUrl]="detailsUrl"
  [storageKey]="storageKey"
  [showPager]="showPager"
  [contextMenuItems]="contextMenuItems"
  [select]="select"
  [expand]="expand"
  (refresh)="refresh()"
></syslink-grid>